import React from 'react';
import './index.css';

export default function VPPResult({ results, filenames, rid, uid }) {
  const [link, year] = filenames[0].split(" ");

  const handleClick = () => {
    window.open(link, "_blank");
  }

  return (
    <div>
      <div className="input-title">
        Link:
      </div>
      <div className="res-input-link" onClick={handleClick}>
        {link}
      </div>
      <div className="input-title">Year:</div>
      <div className="res-year">{year}</div>
      <div className="res-price">Estimated price: ${parseFloat(results[filenames[0]]).toFixed(2)}</div>
    </div>
  )
}
